import request from '../index'
import Vue from 'vue'

/**
 *	百度线索API数据上报
 * @param {*} conversionTypes
 * @retu
 */
export function baiduOCPCReport(conversionTypes) {
    // 统一使用baidu-搜索-榜游框架L-12账号的token上报数据，使用另外的token上报，导致ocpc后台数据不准确的问题
    const channel = Vue.$cookies.get('steamf-gamebox-channel')
    let token = 'Ss9qaDchuKdKZfMbSkxIMsLI43HRRd8V@iUFyY90MAJs7jH4ftVss4dHnvUHHbFtM' // baidu-搜索-榜游框架L-12
    if (channel === 'bangyoua') {
        token = '7EQNhx2v8zF8S0fXh3CXuFP9KQD9ifQ1@7F4vPPtKkTFzD2NaB4DLQzJ0v602tTs6' // baidu-搜索-榜游框架A-09
    } else if (channel === 'bangyoul') {
        token = 'FgzhjEA7sKdXn415HPAIRZySUN770jSQ@vtWdwZkjG2NejocwNCKxrC0qEUKCDNh9' // baidu-搜索-榜游分公司游戏框-L03
    }
    return request({
        url: '/common/baidu',
        method: 'post',
        data: {
            token,
            conversionTypes
        },
        'axios-retry': {
            retries: 0
        }
    })
}
